import { useCondicoesObra } from "../../../hooks/use-condicoes-obra";
import { REVISAO } from "../../../nova-obra.constants";

export function useAvisoStatusCondicoes() {
  const { status } = useCondicoesObra();
  const mensagem =
    status === "ok"
      ? null
      : status === "carregando"
        ? REVISAO.condicoes.carregando
        : REVISAO.condicoes.erro;

  return { mensagem };
}
